import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';

import GameMainBackground from '../../../components/common/gameMainBackground';

const GameBackgroundWrapper = observer(() => {
  const { bgConfig } = useMemo(() => {
    return {
      bgConfig: { x: 0, y: 0 },
    };
  }, []);

  return <GameMainBackground bgConfig={bgConfig} />;
});

export default GameBackgroundWrapper;
